var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-align-center"},[_c('div',{class:['state_icon', _vm.row.group_status == '1' ? 'success' : 'danger']}),_c('div',{staticClass:"ml-10"},[_vm._v(_vm._s(_vm.row.group_status_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }